export default __webpack_public_path__ + "static/media/promo-email.f14d5ad9.png";